import { render, staticRenderFns } from "./GeneralSpecialtiesTable.vue?vue&type=template&id=5f0c5fb3&"
import script from "./GeneralSpecialtiesTable.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports